import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Convert Google Places price level to human-readable text
 * @param priceLevel - The Google Places price level enum value
 * @returns Human-readable price level text
 */
export function formatPriceLevel(
  priceLevel: string | null | undefined
): string {
  if (!priceLevel) return 'Price varies';

  switch (priceLevel) {
    case 'PRICE_LEVEL_FREE':
      return 'Free';
    case 'PRICE_LEVEL_INEXPENSIVE':
      return 'Inexpensive';
    case 'PRICE_LEVEL_MODERATE':
      return 'Moderate';
    case 'PRICE_LEVEL_EXPENSIVE':
      return 'Expensive';
    case 'PRICE_LEVEL_VERY_EXPENSIVE':
      return 'Very expensive';
    case 'PRICE_LEVEL_UNSPECIFIED':
    default:
      return 'Price varies';
  }
}

/**
 * Get CSS classes for price level styling
 * @param priceLevel - The Google Places price level enum value
 * @returns CSS classes for styling the price level
 */
export function getPriceLevelStyles(
  priceLevel: string | null | undefined
): string {
  if (!priceLevel) return 'text-gray-500 dark:text-gray-400';

  switch (priceLevel) {
    case 'PRICE_LEVEL_FREE':
      return 'text-sage-dark font-medium';
    case 'PRICE_LEVEL_INEXPENSIVE':
      return 'text-sage font-medium';
    case 'PRICE_LEVEL_MODERATE':
      return 'text-warm-mid font-medium';
    case 'PRICE_LEVEL_EXPENSIVE':
      return 'text-clay font-medium';
    case 'PRICE_LEVEL_VERY_EXPENSIVE':
      return 'text-terra font-semibold';
    case 'PRICE_LEVEL_UNSPECIFIED':
    default:
      return 'text-warm-mid';
  }
}
